import Page from "webPage/Page";
import Ajax from "base/Ajax";
import AjaxForm, { EVENT_ERROR, EVENT_SUCCESS } from "webPage/AjaxForm";

Page.register('/contact-us', () => {
    let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    let map = new window.google.maps.Map(document.getElementById('map'), {
        center: {lat: 52.381012, lng: -1.254066},
        zoom: 15,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        draggable: false,
        scaleControl: false,
        zoomControl: false,
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#e4e4e4"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d8d8d8"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#c4c4c4"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#cdcdcd"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ]
    });

    const image = {
        size: new google.maps.Size(40, 50),
        scaledSize: new google.maps.Size(40, 50),
        anchor: new google.maps.Point(40, 50),
        url: '/images/svg/marker.' + (isIE11 ? 'png' : 'svg')
    };

    new google.maps.Marker({
        position: {lat: 52.381012, lng: -1.254066},
        map: map,
        icon: image
    });

    handleContactForm();
});

export function handleContactForm() {

    let form = new AjaxForm($(".js-contact-form"), ($form, formData) => {
        return Ajax.post("contact", "", formData, Ajax.WEBSITE);
    }, {
        validatorSettings: {
            inputOptions: {operator: "your"},
            inputs: {
                "g-recaptcha-response": {
                    messages: {
                        empty: "Please complete the recaptcha",
                    },
                },
            },
        },
    });
    form.getButton().prop("disabled", false);

    form.on(EVENT_ERROR, () => {
        grecaptcha.reset();
    });

    form.on(EVENT_SUCCESS, () => {
        $(".js-contact-success").show();
        $(".js-contact-wrap").hide();
    });

    window.onRecaptchaLoad = function () {
        form.validator.updateInputs();
    };
}

window.onRecaptchaLoad = () => {};
